import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewBoxesComponent } from "./med-icon-view-boxes.component";

@NgModule({
  declarations: [
    MedIconViewBoxesComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewBoxesComponent,
  ],
})
export class MedIconViewBoxesModule { }
